import React from "react";
import LogoPic from "../../images/bgpic1.png";
import LogoPic1 from "../../images/bgpic.png";
import "./style.css";
import { Slide, Fade, AttentionSeeker } from "react-awesome-reveal";

function ComponentsFirst() {
  return (
    <div style={{ height: "90vh" }}>
      <Slide direction="left" triggerOnce="true">
        <img
          className="position-absolute img-fluid bgpicposition"
          src={LogoPic}
          alt=""
        />
      </Slide>
      <Slide direction="right" triggerOnce="true">
        <img
          className="position-absolute right-0 img-fluid bgpicposition1"
          src={LogoPic1}
          alt=""
        />
      </Slide>
      <div class="d-flex justify-content-center align-items-center ">
        <div>
          <Fade triggerOnce="true">
            <h1 className="text-center fs-1 text-white mt-5 mb-5 text22">
              Pakistan’s favourite <br />
              contact sharing app
            </h1>
          </Fade>
          <Fade triggerOnce="true">
            <p className="fs-3 text-white text-center mb-5 text33">
              Send and recieve your contact information by creating different
              <br /> profiles according to your need.
            </p>
          </Fade>
          <div class="d-flex justify-content-center align-items-center ">
            <AttentionSeeker effect="headShake" triggerOnce="true">
              <button className="rounded-pill fs-4 text-white  mt-5 mb-3  btnget">
                Get the app
              </button>
            </AttentionSeeker>
          </div>
          <Fade triggerOnce="true">
            <p className="text-center text-white fs-3">
              Click on button to download the app
            </p>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default ComponentsFirst;
